<template>

<div class="date" :class="{'is-flag': flag}">

	<input type="text" class="date-input" v-model="day" maxlength="2" placeholder="DD" v-on:keyup="onKeyUp" />
	<input type="text" class="date-input" v-model="month" maxlength="2" placeholder="MM" v-on:keyup="onKeyUp" />
	<input type="text" class="date-input" v-model="year" maxlength="4" placeholder="YYYY" v-on:keyup="onKeyUp" />

</div>

</template>

<script>

export default {

	props: ['input', 'flag'],

	data: function() {

		return {
			value: '',
			day: '',
			month: '',
			year: ''
		}

	},

	created: function() {

		this.value = this.values[this.input.variable]

		if (this.value) {
		
			this.day = this.value.split('/')[0]
			this.month = this.value.split('/')[1]
			this.year = this.value.split('/')[2]

		}

	},

	methods: {

		onKeyUp: function() {

			this.value = this.day + '/' + this.month + '/' + this.year

			this.$store.dispatch('set', {
				input: this.input.id,
				variable: this.input.variable, 
				value: this.value
			})

		}

	}

}

</script>

<style scoped>

.date {
	display: flex;
	flex-direction: row;
}

.date-input {
	background-color: #f6f6f6;
	height: 48px;
	line-height: 48px;
	padding: 0px 20px;
	border-radius: 24px;
	font-size: 20px;
	color: #343434;
	font-weight: 100;
	border: 2px solid #f6f6f6;
	transition: all 300ms ease-in-out;
	width: 74px;
	margin-left: 4px;
}

.date-input:nth-child(3) {
	width: 96px;
}

.is-mobile .date-input {
	height: 36px;
	font-size: 14px;
	border-radius: 16px;
	width: 100%;
	line-height: 32px;
}

.date.is-flag .date-input {
	border-color: #ee7173;
}

.date-input::placeholder {
	color: #ccc;
}

</style>